import { render } from "./DevolucaoVendaListagem.vue?vue&type=template&id=6272da6e&scoped=true&ts=true"
import script from "./DevolucaoVendaListagem.vue?vue&type=script&lang=ts"
export * from "./DevolucaoVendaListagem.vue?vue&type=script&lang=ts"

import "./DevolucaoVendaListagem.vue?vue&type=style&index=0&id=6272da6e&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6272da6e"]])

export default __exports__